import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "@/app/store";
import { selectUser } from "@/app/store/slices/auth.slice";
import { isBranchAccountUser } from "@/shared/constants";

type TransferListRoute = "central" | "branch";

interface TransferListRouteGuardProps {
  listRoute: TransferListRoute;
  children: ReactNode;
}

/**
 * Branch accounts use /branch-transfers; kitchen accounts use /transfers.
 * Shared detail routes (/transfers/:id) are available to both.
 */
export function TransferListRouteGuard({
  listRoute,
  children,
}: TransferListRouteGuardProps) {
  const user = useAppSelector(selectUser);
  const isBranchUser = isBranchAccountUser(user);

  if (listRoute === "central" && isBranchUser) {
    return <Navigate to="/branch-transfers" replace />;
  }

  if (listRoute === "branch" && !isBranchUser) {
    return <Navigate to="/transfers" replace />;
  }

  return <>{children}</>;
}
